import { render, staticRenderFns } from "./SectionLegal.vue?vue&type=template&id=616897fb&scoped=true"
import script from "./SectionLegal.vue?vue&type=script&lang=ts"
export * from "./SectionLegal.vue?vue&type=script&lang=ts"
import style0 from "./SectionLegal.vue?vue&type=style&index=0&id=616897fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616897fb",
  null
  
)

export default component.exports